import React, { useContext, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import tvImage from '../../../../images/preview/tv.png';
import { css } from '@emotion/core';
import { CtvIroll, IrollEvent } from './CtvIroll';
import { DemoContext } from '../../Demo';
import { PlayerErrorBoundary } from './PlayerErrorBoundary';
import { LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as Play } from '../../../../images/preview/tv_play.svg';
import { ErrorLevel } from '../../error/error';
import 'react-aspect-ratio/aspect-ratio.css'
import AspectRatio from 'react-aspect-ratio';

export const CtvPlayer = () => {
  const { previewUrl, error } = useContext(DemoContext);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState(false);
  const { irollIframe, sendIrollRequest } = CtvIroll({ previewUrl, irollEventMap: {
      [IrollEvent.READY]: () => setLoading(false),
      [IrollEvent.ENDED]: () => {
        setLoading(true);
        setPlaying(false);
      },
    }
  });


  const startPlay = () => {
    setPlaying(true);
    sendIrollRequest(IrollEvent.REQUEST_START);
  };

  useEffect(() => {
    setPlaying(false);
    setLoading(true);
  }, [previewUrl]);

  useEffect(() => {
    !!error && setLoading(false);
  }, [error]);


  return <AspectRatio ratio={1606/1019} style={{
    width:'68%',
    backgroundImage: `url(${tvImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display:'flex',
    top:'3%'
  }}>
    <TvContainer>
      {error?.level !== ErrorLevel.ERROR &&irollIframe}
       { !playing &&
        <PlayerErrorBoundary error={error}>
          {loading ? <LoadingOutlined css={spinner}/> : <PlayButton onClick={startPlay}/>}
        </PlayerErrorBoundary>}
    </TvContainer>
  </AspectRatio>;

};

const PlayButton = ({ onClick }) =>{
  const onImageClick = (e) => {
    e.stopPropagation();
    onClick();
  };
  return <PlayContainer id='play_btn' onClick={onImageClick}>
    <Play css={playIcon}/>
  </PlayContainer>
};

const PlayContainer = styled.div`
  position: absolute;
  width: 99.5%;
  height: 90%;
  background-color: #272727;
  border: none;
  top: 0.2%;
  left: 0.25%;
  z-index: 10;
  display: inline-flex;
  justify-content: center;
  align-items: start;
`;

const playIcon = css`
  width: 9%;
  fill: #7b7b7b;
  position: relative;
  top: 42%;
  opacity: 1;
`;

const spinner = css`
    position: absolute;
    top: 34%;
    color:white;
    font-size: 5vw;
`;

const TvContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
